import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/global/modals/ModalComponent";
import SkeletonTable from "../../../components/table/SkeletonTable";
import licenseHistoryColumns from "../../../columns/License/LicenseHistoryColumns";
import { GetLicenseHistoryApi } from "../../../api/request/license";
import toast from "react-hot-toast";

const LicenseHistoryModal = ({ isOpen, setIsOpen, licenseId }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchHistory = async () => {
    if (!licenseId) return;
    try {
      setIsLoading(true);
      const { data } = await GetLicenseHistoryApi({ license_id: licenseId });
      setData(data?.data?.history || []);
    } catch (error) {
      console.error("Error fetching license history:", error);
      toast.error(error?.response?.data?.message || "Failed to fetch history");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen && licenseId) fetchHistory(); 
    else setData([]);
  }, [isOpen, licenseId]);

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="License History"
      width={1200}
    >
      <div className="border bg-white rounded-xl py-3">
        <SkeletonTable
          stickHeader={true}
          columns={licenseHistoryColumns}
          data={data}
          isLoading={isLoading}
          pagination={true}
          rowKey="id"
        />
      </div>
    </ModalComponent>
  );
};

export default LicenseHistoryModal;
